import { logSafeErrorWithoutCustomerData } from '@atlassian/jira-common-directory-v2/src/utils/log-safe-error';
import { FILTERS_ERROR_ANALYTICS } from '@atlassian/jira-filters-common/src/common/constant';
import type { EditableFilter } from '@atlassian/jira-filters-common/src/model';
import editRest from '../../rest';
import { transformEditableFilter } from '../transformers';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (
	id: string,
	filter: EditableFilter,
	overrideSharePermissions: boolean,
): Promise<void> => {
	const body = transformEditableFilter(filter);

	try {
		await editRest(id, body, overrideSharePermissions);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		logSafeErrorWithoutCustomerData(
			error,
			'directories.filters-v2.edit-modal.edit-filter',
			FILTERS_ERROR_ANALYTICS,
		);
		throw error;
	}
};
